var map = {
	"./ADE.svg": "LI1V",
	"./BRL.svg": "MMSD",
	"./CAR.svg": "MweT",
	"./COL.svg": "kpPL",
	"./ESS.svg": "4yGy",
	"./FRE.svg": "0/kA",
	"./GCS.svg": "3ODh",
	"./GEE.svg": "GD3c",
	"./GWS.svg": "F+lq",
	"./HAW.svg": "uocx",
	"./MEL.svg": "rZgR",
	"./NTH.svg": "3pcx",
	"./PTA.svg": "9JQp",
	"./RIC.svg": "v4uv",
	"./STK.svg": "d7Db",
	"./SYD.svg": "KWKB",
	"./WBD.svg": "x6mV",
	"./WCE.svg": "+9im",
	"./codesports.svg": "sd/s"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 1